module.exports = __webpack_public_path__ + "static/media/namecheap-logo.9dcb2167.webp";